import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "department-history-new",
  components: {
    AppHeader
  },
  async created() {
    this.getLatestHistory();
    await this.getUser();
    this.getDepartment();
    await this.getTodayDate();
  },
  data() {
    return {
      canChoiceYears: [],
      dayCount: "",
      changeYear: "",
      changeMonth: "",
      changeDay: "",
      departmentHistory: {
        user_id: this.$route.params.user_id,
        department_id_before: "",
        department_name_before: "",
        department_id_after: "",
        department_name_after: ""
      },
      user: "",
      departments: "",
      getDepartmentsEnd: false,
      latestHistory: null,
      savingFlag: false
    };
  },
  computed: {
    changeDateFormat() {
      return dayjs(
        `${this.changeYear}-${this.changeMonth}-${this.changeDay}`
      ).format("YYYY-MM-DD");
    },
    changeDateBeforeToday() {
      if (this.changeYear && this.changeMonth && this.changeDay) {
        if (this.changeDateFormat <= dayjs().format("YYYY-MM-DD")) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    changeDateBeforeLatest() {
      if (this.changeYear && this.changeMonth && this.changeDay) {
        if (
          this.latestHistory == null ||
          this.changeDateFormat >
            dayjs(this.latestHistory.change_date).format("YYYY-MM-DD")
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    isSameDepartments() {
      if (
        this.user.department_id == this.departmentHistory.department_id_after
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    async getLatestHistory() {
      let data = {
        user_id: this.$route.params.user_id
      };
      let res = await this.$store
        .dispatch("GET_LATEST_DEPARTMENT_HISTORY", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.latestHistory = res.latest_history;
    },
    async getDepartment() {
      let data = {
        company_id: this.user.company_id
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
      this.getDepartmentsEnd = true;
    },
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      for (let i = 0; i < 60; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
      this.dayCount = new Date(this.changeMonth, this.changeDay, 0).getDate();
    },
    async createDepartmentHistory() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      this.departmentHistory.change_date = this.changeDateFormat;
      this.departmentHistory.department_id_before = this.user.department_id;
      this.departmentHistory.department_name_before = this.user.department_name;
      let findDepartment = this.departments.find(
        department =>
          department.id == this.departmentHistory.department_id_after
      );
      this.departmentHistory.department_name_after = findDepartment.name;
      let data = this.departmentHistory;
      let res = await this.$store
        .dispatch("CREATE_DEPARTMENT_HISTORY", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.goDepartmentHistory();
      }
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    },
    goDepartmentHistory() {
      this.$router.push({
        path: `/department_history/${this.$route.params.user_id}`
      });
    },
    getDayCount() {
      this.changeDay = "";
      this.dayCount = new Date(this.changeYear, this.changeMonth, 0).getDate();
    }
  }
};
